// 常量定义

export const TOKEN_STATUS = {
  ENABLED: 1,
  DISABLED: 2,
  EXPIRED: 3,
  EXHAUSTED: 4,
} as const

export const TOKEN_STATUS_TEXT: Record<number, string> = {
  1: '已启用',
  2: '已禁用',
  3: '已过期',
  4: '额度用尽',
}

export const USER_ROLE = {
  COMMON: 1,
  ADMIN: 10,
  ROOT: 100,
} as const

export const USER_ROLE_TEXT: Record<number, string> = {
  1: '普通用户',
  10: '管理员',
  100: '超级管理员',
}

export const USER_STATUS = {
  ENABLED: 1,
  DISABLED: 2,
} as const

export const CHANNEL_STATUS = {
  ENABLED: 1,
  MANUALLY_DISABLED: 2,
  AUTO_DISABLED: 3,
} as const

export const CHANNEL_STATUS_TEXT: Record<number, string> = {
  0: '未知',
  1: '已启用',
  2: '已禁用',
  3: '自动禁用',
}

export const LOG_TYPE = {
  ALL: 0,
  TOPUP: 1,
  CONSUME: 2,
  MANAGE: 3,
  SYSTEM: 4,
  ERROR: 5,
  REFUND: 6,
} as const

export const LOG_TYPE_TEXT: Record<number, string> = {
  0: '全部',
  1: '充值',
  2: '消费',
  3: '管理',
  4: '系统',
  5: '错误',
  6: '退款',
}

// 渠道类型（与后端 CHANNEL_OPTIONS 常见项对齐，简化列出）
export const CHANNEL_TYPES = [
  { key: 1, value: 1, text: 'OpenAI', label: 'OpenAI', color: 'green' },
  { key: 2, value: 2, text: 'Midjourney Proxy', label: 'Midjourney Proxy', color: 'arcoblue' },
  { key: 3, value: 3, text: 'Azure OpenAI', label: 'Azure OpenAI', color: 'cyan' },
  { key: 14, value: 14, text: 'Anthropic Claude', label: 'Anthropic Claude', color: 'purple' },
  { key: 33, value: 33, text: 'AWS Bedrock', label: 'AWS Bedrock', color: 'orangered' },
  { key: 24, value: 24, text: 'Google Gemini', label: 'Google Gemini', color: 'orange' },
  { key: 11, value: 11, text: 'Google PaLM2', label: 'Google PaLM2', color: 'lime' },
  { key: 15, value: 15, text: '百度文心千帆', label: '百度文心千帆', color: 'blue' },
  { key: 17, value: 17, text: '阿里通义千问', label: '阿里通义千问', color: 'red' },
  { key: 16, value: 16, text: '智谱 ChatGLM', label: '智谱 ChatGLM', color: 'pinkpurple' },
  { key: 23, value: 23, text: '讯飞星火', label: '讯飞星火', color: 'magenta' },
  { key: 19, value: 19, text: '360 智脑', label: '360 智脑', color: 'arcoblue' },
  { key: 25, value: 25, text: 'Moonshot AI', label: 'Moonshot AI', color: 'purple' },
  { key: 26, value: 26, text: '百川', label: '百川', color: 'lime' },
  { key: 27, value: 27, text: 'MiniMax', label: 'MiniMax', color: 'orangered' },
  { key: 29, value: 29, text: '腾讯混元', label: '腾讯混元', color: 'green' },
  { key: 31, value: 31, text: '零一万物', label: '零一万物', color: 'magenta' },
  { key: 36, value: 36, text: 'DeepSeek', label: 'DeepSeek', color: 'arcoblue' },
  { key: 40, value: 40, text: 'ByteDance 豆包', label: 'ByteDance 豆包', color: 'cyan' },
  { key: 41, value: 41, text: 'Novita', label: 'Novita', color: 'purple' },
  { key: 45, value: 45, text: 'xAI Grok', label: 'xAI Grok', color: 'gray' },
  { key: 8, value: 8, text: '自定义', label: '自定义', color: 'gray' },
]

export const CHANNEL_TYPE_MAP = CHANNEL_TYPES.reduce<Record<number, string>>((acc, item) => {
  acc[item.value] = item.text
  return acc
}, {})

// 分页默认配置
export const DEFAULT_PAGE_SIZE = 20

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100]
